import { Button, Grid } from '@mui/material';
import React, { useEffect, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import ElementTable from './element';
import Graph from '../graph-limits/graph'
import { UserContext } from '../../contexts/context-layout-user';
import NkChart from '../n-k/graph';
import { Outlet } from 'react-router-dom';

const LimitsFunctionality = (props) => {
  const { t } = useTranslation("global");
  const [selectedButton, setSelectedButton] = React.useState(null);
  const [data, setData] = React.useState({});
  const { element, flexibility, setFlexibility, generatorData } = useContext(UserContext);

  const styleButton = (button) => ({
    backgroundColor: selectedButton === button ? '#551a8b' : '#cccccc',
    borderRadius: '10px 10px 0px 0px',
    cursor: 'pointer',
    fontSize: '16px',
    color: '#ffffff',
    marginLeft: '10px',
  });

  useEffect(() => {
    setSelectedButton('Element');
  }, []);

  useEffect(() => {
    const auxData = {
      familyName: generatorData[0]?.familyId || '',
      cases: generatorData || [],
    }
    setData(auxData);
  }, [generatorData]);

  return (
    <Grid >
      <Grid >
        <Grid item xs={12} style={{ textAlign: 'start', marginLeft: '3%' }}>
          <Button
            style={styleButton('Flexibility')}
            onClick={() => {
              setSelectedButton('Flexibility');
              setFlexibility(true);
            }}
          >
            {t("generator.limits.flexibilityButton")}
          </Button>
          <Button
            style={styleButton('Generation')}
            onClick={() => setSelectedButton('Generation')}
          >
            {t("generator.limits.generationButton")}
          </Button>
          <Button
            style={styleButton('Element')}
            onClick={() => setSelectedButton('Element')}
          >
            {t("generator.limits.elementButton")}
          </Button>
        </Grid>
      </Grid>
      <Grid item xs={11}>
        {selectedButton === 'Flexibility' && (
          flexibility ?
            <NkChart familyCases={data} />
            // <h1>entra true</h1>
            :
            <Outlet />
        )}
        {selectedButton === 'Generation' && (
          <Graph data={generatorData} />
        )}
        {selectedButton === 'Element' && (
          <ElementTable data={element?.result?.data} />
        )}
      </Grid>
    </Grid>
  );
};

export default LimitsFunctionality;
